"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterMenuBody = void 0;
const react_1 = __importDefault(require("react"));
const Dialog_1 = require("../Dialog");
const FilterMenuFooter_1 = require("./components/FilterMenuFooter/FilterMenuFooter");
const FilterMenuHeader_1 = require("./components/FilterMenuHeader/FilterMenuHeader");
const FilterMenuBody_styles_1 = require("./FilterMenuBody.styles");
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const View_1 = require("../View");
exports.FilterMenuBody = (0, helpers_1.createUIElement)('FilterMenuBody', (_a, ref) => {
    var { className, title, headerAddon, children, content, actions, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "title", "headerAddon", "children", "content", "actions", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(StackView_1.StackView, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'filter-menu-body', className: (0, helpers_1.cn)('vm-FilterMenuBody', className), direction: StackView_1.STACK_DIRECTION.column, spaceAll: View_1.INDENT.m, spaceTop: View_1.INDENT.xs, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(FilterMenuHeader_1.FilterMenuHeader, { title: title }, headerAddon),
        react_1.default.createElement(FilterMenuBody_styles_1.StyledFilterMenuBody, null, children || content),
        !!actions && !!actions.length && (react_1.default.createElement(FilterMenuFooter_1.FilterMenuFooter, null,
            react_1.default.createElement(Dialog_1.DialogActions, { distribution: Dialog_1.DIALOG_ACTIONS_DISTRIBUTION.end, primary: actions })))));
});
//# sourceMappingURL=FilterMenuBody.js.map